import React from "react";
import ContactTemplate from "../components/template/ContactTemplate";

function Contact() {
  return (
    <>
      <ContactTemplate />
    </>
  );
}

export default Contact;
